
import React, { useEffect, useRef, useState } from "react";
import { FaFileInvoice, FaChevronLeft } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import commonNetwork from "../../common/api/commonNetwork"
import { formatCurrency, formatDateOnFront } from "../../lib/helpers";
import { Button } from "../components/Elements";
import StatusBox from "../components/Elements/StatusBox";
import PaymentSlipModal from "../components/PaymentSlipModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faFileArrowDown } from "@fortawesome/free-solid-svg-icons";
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import Loading from "../components/Loading";
import { usePermissionCheck } from "../../hooks/usePermissionCheck";
import { UserOperationTypes } from "../../common/types/AuthorizationProps";


const OrderDetail = (props) => {
    usePermissionCheck(UserOperationTypes["İşlem Listesi"], "Tahsilat Hareketlerini görüntüleme izni yok");
    let navigate = useNavigate();
    let { orderCode } = useParams();
    const paymentSlipModalRef = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const [orderDetailInfo, setOrderDetailInfo] = useState({
        "id": 0,
        "orderDate": "",
        "transactionId": "",
        "vpDisplayName": "",
        "orderStatus": "",
        "transactionType": "",
        "isTest": false,
        "firstAmount": "",
        "lastAmount": "",
        "installment": 0,
        "commissionRate": 0,
        "commissionAmount": 0,
        "resource": "",
        "customerCode": "",
        "firstName": "",
        "lastName": "",
        "customerName": "",
        "taxCode": "",
        "tcCode": null,
        "taxOffice": "",
        "country": "",
        "city": "",
        "district": null,
        "postalCode": null,
        "address": "",
        "email": "",
        "phone": null,
        "bankRefNo": "",
        "clientIp": "",
        "productName": "",
        "productAmount": "",
        "currency": "",
        "cardOwner": "",
        "cardBrand": "",
        "cardType": "",
        "cardBank": "",
        "cardMask": "",
        "orderDescription": null,
        "invoiceNo": null,
        "createUserName": "",
        "syncCustomerCode": null,
        "createDate": "",
        "lastDate": "",
        "resultCode": null,
        "resultDesc": null,
        "resultDesc2": null,
        "statusDesc": "",
        "currencySymbol": "₺",
        extraInstallmentCount: "",
        installmentDeferralCount: "",
        invoiceNumber: "",
        gibInvoiceNumber: "",
        parentUserDescription: "",
        childUserDescription: "",
        syncCustomerDescription: "",

    });

    useEffect(() => {

        selectDetailInformation();
    }, [])

    const selectDetailInformation = async () => {
        var params = {
            transactionId: orderCode
        }
        const result = await commonNetwork.get("/payment/order-detail", params);

        setOrderDetailInfo(result.data);
    }

    const openPaymentSlip = () => {
        paymentSlipModalRef.current.showPaymentSlip({
            orderId: orderDetailInfo.id
        });
    }

    const onDownloadSlipClick = () => {


        paymentSlipModalRef.current.downloadPaymentSlip({
            orderId: orderDetailInfo.id,
            orderCode: orderDetailInfo.transactionId
        });
    }
    const getOrderStatusClass = (status, desc, transactionType, firstAmount, lastAmount) => {
        var firstamount = parseFloat(firstAmount);
        var lastamount = parseFloat(lastAmount);

        switch (transactionType) {
            case "sales":
                switch (status) {
                    case "success":
                        return <StatusBox className="px-2" content={desc} statusType={"success"} />
                    case "failed":
                        return <StatusBox className="px-2" content={desc} statusType={"error"} />
                    case "waiting":
                        return <StatusBox className="px-2" content={desc} statusType={"primary"} />
                }
            case "cancel":
                return <StatusBox className="px-2" content={"İptal"} statusType={"warning"} />

            case "refund":
                if (firstamount != lastAmount && lastAmount != 0) {
                    return <StatusBox className="px-2" content={"Kısmi İade"} statusType={"warning"} />
                } else {
                    return <StatusBox className="px-2" content={"İade"} statusType={"warning"} />
                }
        }
    }

    function getInstallment(installment) {

        if (installment) {
            if (installment == 1) {
                return "Peşin"
            } else {
                return installment + " Taksit";
            }
        } else {
            return "Peşin"
        }

    }

    // apiden dönen parametre float yapilabilir
    function formatFloat(amountStr) {
        const length = amountStr.length;

        if (length > 2) {
            return amountStr.slice(0, length - 2) + '.' + amountStr.slice(length - 2);
        }

        return '0.' + amountStr.padStart(2, '0');
    }

    return (
        <div>
            <PageTitle title={pageTitleTexts.orderDetail} />
            {orderDetailInfo.id === 0 ? <Loading /> :
                <>
                    <div className=" m-1 p-1">
                        <Button
                            size="lg"
                            color="gray"
                            hover="gray"
                            type="button"
                            callback={() => {
                                navigate(-1);
                            }}
                        >
                            <FaChevronLeft
                                className="block hidden sm:block ml-2 h-3 w-3 font-light mr-2"
                                aria-hidden="true"
                            />
                            Geri Dön
                        </Button>
                    </div>

                    <div className="m-2 p-2 bg-white shadow-md sm:text-sm md:text-sm lg:text-base rounded-md">
                        <div className="flex flex-row break-words">
                            <div className="xl:basis-1/3 lg:basis-1/2 md:basis-1/2 sm:basis-1/2 m-1 p-1">
                                <div className="flex  m-1 p-1 bg-primary-navbar ">
                                    <img src="/icons/clipboard-white.svg" alt="islem_detaylari" />
                                    <span className="font-bold text-white pl-1 pt-1">İşlem Detayları</span>
                                </div>
                                <div className=" m-1 p-1 ">
                                    <div className="my-1 py-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Sipariş Kodu: </div>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.transactionId}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">İşlem Modeli: </div>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.modalId === 5 ? "Non Secure" : "3D Secure"}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">İlk İşlem Zamanı: </div>
                                        <div className="basis-7/12 text-sm">{formatDateOnFront(orderDetailInfo.orderDate)} </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <span className="basis-5/12 font-bold text-black-50 text-sm">
                                            Son İşlem Zamanı:
                                        </span>
                                        <div className="basis-7/12 text-sm">{formatDateOnFront(orderDetailInfo.lastDate)}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">İşlem Sonucu: </div>
                                        {getOrderStatusClass(orderDetailInfo.orderStatus, orderDetailInfo.statusDesc, orderDetailInfo.transactionType, orderDetailInfo.firstAmount, orderDetailInfo.lastAmount)}
                                        {/* <div className={getOrderStatusClass(orderDetailInfo.orderStatus, orderDetailInfo.statusDesc)}> {orderDetailInfo.statusDesc}</div> */}
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">İşlem Tutarı: </div>
                                        <div className="basis-7/12 text-sm"> {formatCurrency(parseFloat(orderDetailInfo.firstAmount))} {orderDetailInfo.currencySymbol} </div>
                                    </div>
                                    {/* <div className="mb-1 pb-1  flex flex-row ">
                                <div className="basis-5/12 font-bold text-sm">Kalan Tutar: </div>
                                <div className="basis-7/12 text-sm">{formatCurrency(parseFloat(orderDetailInfo.lastAmount))} ₺</div>
                            </div> */}
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Kalan Tutar: </div>
                                        <div className="basis-7/12 text-sm"> {formatCurrency(parseFloat(formatFloat(orderDetailInfo.lastAmount)))} {orderDetailInfo.currencySymbol} </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Komisyon Hariç Tutar: </div>
                                        <div className="basis-7/12 text-sm"> {formatCurrency(parseFloat(orderDetailInfo.firstAmount - orderDetailInfo.commissionAmount))} {orderDetailInfo.currencySymbol} </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Komisyon Tutarı:</div>
                                        <div className="basis-7/12 text-sm">{formatCurrency(parseFloat(orderDetailInfo.commissionAmount))} {orderDetailInfo.currencySymbol}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Taksit Sayısı: </div>
                                        <div className="basis-7/12 text-sm"> {getInstallment(orderDetailInfo.installment)}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Ödeme Altyapısı: </div>
                                        <div className="basis-7/12 text-sm"> {orderDetailInfo.vpDisplayName}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Ödeme Modu: </div>
                                        <div className="basis-7/12 text-sm"> {orderDetailInfo.isTest ? "Test" : "Canlı Ortam"} </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Ödeme Kaynağı:</div>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.resource}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Ip Bilgisi:</div>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.clientIp}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Açıklama:</div>
                                        <div className="basis-7/12 text-sm"> {orderDetailInfo.orderDescription}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Artı Taksit Sayısı:</div>
                                        <div className="basis-7/12 text-sm"> {orderDetailInfo.extraInstallmentCount}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Taksit Erteleme Sayısı:</div>
                                        <div className="basis-7/12 text-sm"> {orderDetailInfo.installmentDeferralCount}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="xl:basis-1/3 lg:basis-1/2 md:basis-1/2 sm:basis-1/2  m-1 p-1">
                                <div className="flex m-1 p-1 bg-primary-navbar">
                                    <img src="/icons/clipboard-white.svg" alt="odeme_bilgileri" />
                                    <span className="font-bold  text-white pl-1 pt-1">Ödeme Bilgileri</span>
                                </div>
                                <div className=" m-1 p-1 ">
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Müşteri Adı: </div>
                                        <div className="basis-7/12 text-sm break-all">
                                            {orderDetailInfo.customerName}
                                        </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Ödemeyi Alan: </div>
                                        <div className="basis-7/12 text-sm"> {orderDetailInfo.createUserName}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">
                                            Kart Üzerindeki İsim:{" "}
                                        </div>
                                        <div className="basis-7/12 ">{orderDetailInfo.firstName + " " + orderDetailInfo.lastName} </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <span className="basis-5/12 font-bold text-black-50 text-sm">E-Posta:</span>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.email}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Kart Bilgisi: </div>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.cardBank + " **** **** " + orderDetailInfo.cardMask}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Kart Tipi: </div>
                                        <div className=" bg-warning font-semibold  rounded-lg px-2 text-sm"> {orderDetailInfo.cardType} </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Kart Türü: </div>
                                        <div className="font-semibold  rounded-lg px-2 text-sm"> {orderDetailInfo.cardName} </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Kart Ailesi: </div>
                                        <div className="basis-7/12 text-sm"> {orderDetailInfo.cardBrand}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">
                                            Kart Bankası:
                                        </div>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.cardOwner}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">
                                            Referans Numarası:
                                        </div>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.bankRefNo}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Onay Kodu:</div>
                                        <div className="basis-7/12 text-sm"> {orderDetailInfo.authCode}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="xl:basis-1/3 lg:basis-1/2 md:basis-1/2 sm:basis-1/2  m-1 p-1">
                                <div className="flex m-1 p-1 bg-primary-navbar">
                                    <img src="/icons/clipboard-white.svg" alt="islem_detaylari" />
                                    <span className="font-bold text-white pl-1 pt-1">Müşteri Bilgileri</span>
                                </div>
                                <div className=" m-1 p-1 ">
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm"> Ad-Soyad: </div>
                                        <div className="basis-7/12 text-sm break-all">{orderDetailInfo.firstName + " " + orderDetailInfo.lastName}</div>
                                    </div>
                                    {orderDetailInfo.invoiceNumber && (
                                        <div className="my-1 py-1  flex flex-row ">
                                            <div className="basis-5/12 font-bold">Fatura Numarası: </div>
                                            <div className="basis-7/12 "> {orderDetailInfo.invoiceNumber}</div>
                                        </div>
                                    )}
                                    {orderDetailInfo.gibInvoiceNumber && (
                                        <div className="my-1 py-1  flex flex-row ">
                                            <div className="basis-5/12 font-bold">Gib Fatura Numarası: </div>
                                            <div className="basis-7/12 "> {orderDetailInfo.gibInvoiceNumber}</div>
                                        </div>
                                    )}
                                    {orderDetailInfo.tcCode ? (
                                        <div className="mb-1 pb-1  flex flex-row ">
                                            <div className="basis-5/12 font-bold text-black-50 text-sm">T.C. Kimlik No: </div>
                                            <div className="basis-7/12 text-sm"> {orderDetailInfo.tcCode}</div>
                                        </div>
                                    ) : null}


                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <span className="basis-5/12 font-bold text-black-50 text-sm break-all">Firma Ünvanı:</span>
                                        <div className="basis-7/12 text-sm">
                                            {orderDetailInfo.customerName}
                                        </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <span className="basis-5/12 font-bold text-black-50 text-sm">Cari Kod:</span>
                                        <div className="basis-7/12 text-sm">
                                            {orderDetailInfo.customerCode}
                                        </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Vergi Numarası:</div>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.taxCode}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Vergi Dairesi:</div>
                                        <div className="basis-7/12 text-sm"> {orderDetailInfo.taxOffice} </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Telefon: </div>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.phone}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Adres:</div>
                                        <div className="basis-7/12 text-sm">
                                            {orderDetailInfo.address}
                                        </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Posta Kodu:</div>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.postalCode}</div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Şehir:</div>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.city} </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Bayi:</div>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.parentUserDescription} </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Alt Bayi:</div>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.childUserDescription} </div>
                                    </div>
                                    <div className="mb-1 pb-1  flex flex-row ">
                                        <div className="basis-5/12 font-bold text-black-50 text-sm">Ödemenin Bağlı Olduğu Cari Hesap Ünvan:</div>
                                        <div className="basis-7/12 text-sm">{orderDetailInfo.syncCustomerDescription} </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {orderDetailInfo.orderStatus == "failed" ? (
                            <div>
                                <div className="bg-error  mx-2 px-2 my-1 py-1">
                                    <span className=" text-white pl-1 ">Ödeme Hata Bilgileri</span>
                                </div>
                                <div className="m-2 p-2  flex flex-row ">
                                    <div className="basis-5/12 font-bold">Hata Kodu:</div>
                                    <div className="basis-7/12 ">{orderDetailInfo.resultCode}</div>
                                </div>
                                <div className="m-2 p-2  flex flex-row ">
                                    <div className="basis-5/12 font-bold"> Hata Mesajı:</div>
                                    <div className="basis-7/12 ">{orderDetailInfo.resultDesc}</div>
                                </div>
                                {orderDetailInfo.resultDesc2 ? (
                                    <div className="m-2 p-2  flex flex-row ">
                                        <div className="basis-5/12 font-bold"> Hata Açıklama:</div>
                                        <div className="basis-7/12 ">
                                            {orderDetailInfo.resultDesc2}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : null}

                        {orderDetailInfo.orderStatus == "success" ? (
                            <div className="flex justify-center">
                                <Button
                                    color="gray"
                                    hover="gray"
                                    size="xs"
                                    className={"w-[156px]"}
                                    loading={isLoading}
                                    disabled={isLoading}
                                    callback={() => openPaymentSlip()}
                                    loadingclass={"text-black"}
                                >
                                    <FaFileInvoice
                                        className="block hidden sm:block ml-2 h-3 w-3 font-light mr-2"
                                        aria-hidden="true"
                                    />
                                    {"Dekont Görüntüle"}
                                </Button>

                                <Button
                                    color="gray"
                                    hover="gray"
                                    size="xs"
                                    className={"ml-2 w-[156px]"}
                                    loading={isLoading}
                                    disabled={isLoading}
                                    callback={() => onDownloadSlipClick()}
                                    loadingclass={"text-black"}
                                >
                                    {/* <FileDownload fontSize="small" /> */}
                                    <FontAwesomeIcon icon={faDownload} fontSize={16} className="mr-2" />
                                    {"Dekont İndir"}
                                </Button>
                            </div>
                        ) : null}

                        <PaymentSlipModal ref={paymentSlipModalRef} isLoading={isLoading} setIsLoading={setIsLoading}></PaymentSlipModal>

                    </div>
                </>}
        </div>
    );
}
export default OrderDetail;


